import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./searchInput.html";
/**
 * Shared listing search field used by Package Components and Package Files. The component owns
 * the complete visual boundary so icon/input composition and focus thickness cannot drift.
 */
class SearchInput extends LightningElement {
  constructor(...args) {
    super(...args);
    this.value = '';
    this.placeholder = '';
    this.disabled = false;
    this.variant = 'default';
    this.iconSize = 'small';
  }
  get controlClass() {
    return ['search-control', this.variant === 'compact' ? 'search-control--compact' : ''].filter(Boolean).join(' ');
  }
  handleInput(event) {
    this.dispatchEvent(new CustomEvent('searchinput', {
      detail: {
        value: event.target.value
      }
    }));
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(SearchInput, {
  publicProps: {
    value: {
      config: 0
    },
    placeholder: {
      config: 0
    },
    disabled: {
      config: 0
    },
    variant: {
      config: 0
    },
    iconSize: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(SearchInput, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;